import type { LayoutServiceData } from '@sitecore-jss/sitecore-jss/layout';
import type { RedirectTarget } from '@/types';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const classifyRedirectUrl = (url: unknown): RedirectTarget => {
  if (typeof url !== 'string' || !url?.trim() || url.trim() !== url) {
    return { type: 'invalid', url };
  }

  if (url.startsWith('/') && !url.startsWith('//') && !url.includes('\\')) {
    return { type: 'internal', url };
  }

  if (URL.canParse(url)) {
    const protocol = new URL(url).protocol;
    if (protocol === 'http:' || protocol === 'https:') {
      return { type: 'external', url };
    }
  }

  return { type: 'invalid', url };
};

export const isLayoutServiceData = (data: unknown): data is LayoutServiceData =>
  isRecord(data) && isRecord(data.sitecore) && isRecord(data.sitecore.context);

export const getLayoutServiceRedirect = (data: unknown): RedirectTarget | null => {
  if (!isRecord(data) || !('redirect' in data)) return null;

  const redirect = data.redirect;
  const url = isRecord(redirect) ? redirect.redirectUrl : undefined;

  return classifyRedirectUrl(url);
};
